module.exports = TextEncoder;


//////////////////
// WEBPACK FOOTER
// external "TextEncoder"
// module id = 57
// module chunks = 0